import { SignIn } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/login')({
  component: LoginPage,
});

function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <SignIn routing="hash" forceRedirectUrl="/sequences" signUpUrl="/login#/sign-up" />
    </div>
  );
}
